<template >
  <div class="container" v-if="department">
    <div class="row">
      <div class="col col-expand">
        <h1>{{ department.name }} анги - {{ department.startYear }}</h1>
        <!-- <p>{{department.description}}</p> -->
      </div>
      <div class="col col-auto">
        <button type="button" class="btn btn-primary my-3" @click="_addProgram">
          Бүлэг нэмэх
        </button>
      </div>
    </div>

    <!-- DataTales Example -->
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h6 class="m-0 font-weight-bold text-primary">Бүлгүүд</h6>
          </div>
        </div>
      </div>
      <div class="card-body" v-if="pros != null && pros.length > 0">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th width="1%">№</th>
                <th>Нэр</th>
                <th style="width: 2%" title="Сурагчдын тоо">С.тоо</th>
                <th>Ангийн багш</th>
                <th style="width: 5%">Онлайн өрөө</th>
                <th>Ирц</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(p, index) in pros" v-bind:key="p.id">
                <td>{{ index + 1 }}</td>
                <td class="text-primary">
                  {{ p.name.toUpperCase() }}
                  <!-- 
                    {{p.ref.path}} -->
                </td>
                <td>{{ p.numberOfStudents }}</td>
                <td>
                  <div v-if="p.teacherData">
                    {{ p.teacherData.name }} <br />
                    {{ p.teacherData.email }} <br />
                    {{ p.teacherData.phone }}
                  </div>
                </td>
                <td>
                  <span @click="_openLink(p)" class="text-primary calllink">{{
                    p.onlineroom
                  }}</span>
                </td>
                <td v-if="getPercent(p) == 0 || getPercent(p) == null">-</td>
                <td v-else>{{ getPercent(p) }}%</td>
                <td>
                  <!-- <button class="btn btn-info btn-sm mr-2" @click="$router.push({ name: 'SProgramLessons', params:{ schoolId: schoolId, programId: p.id , departmentId: departmentId} })">хичээлүүд</button> -->
                  <button
                    class="btn btn-warning btn-sm mr-2"
                    @click="_editProgram(p)"
                  >
                    Засах
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    @click="
                      $router.push({
                        name: 'IGroupStudents',
                        params: {
                          schoolId: schoolId,
                          departmentId: departmentId,
                          programId: p.id,
                        },
                      })
                    "
                  >
                    Сурагчид
                  </button>
                  <button
                    class="btn btn-outline-primary btn-sm"
                    @click="
                      $router.push({
                        name: 'IGroupStudents',
                        params: {
                          schoolId: schoolId,
                          departmentId: departmentId,
                          programId: p.id,
                        },
                      })
                    "
                  >
                    Xичээлүүд
                  </button>
                  <!-- <button class="btn btn-danger" @click="_deleteProgram(p)">устгах</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-warning">Одоогоор ороогүй байна.</div>
    </div>
    <div class="card shadow my-4" v-if="!isXAdmin(userProfile)">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h6 class="m-0 font-weight-bold text-primary">
              Заавал судлах хичээлийн жагсаалт
            </h6>
          </div>
          <div class="col col-auto">
            <div class="col-auto">
              <!-- <div @click="$router.push({ 'name':'ILessonAdd' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm mr-2">Хичээл нэмэх</div> -->
              <!-- <div @click="$router.push({ 'name':'ILessonAddGroup' , params:{ schoolId: schoolId, setTeacher: true}})" class="btn btn-danger btn-sm">Хичээл багцалж нэмэх</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div
          class="table-responsive"
          v-if="categories != null && categories.length > 0"
        >
          <table
            class="table table-sm table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Нэр</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(teacher, index) in categories"
                v-bind:key="teacher.id"
              >
                <td>{{ index + 1 }}</td>
                <td>{{ teacher.name }}</td>
                <!-- <td>
                                <span class="badge badge-success" v-if="teacher.typeDetail">
                                    {{teacher.typeDetail.name}}
                                </span>
                            </td> -->

                <td>
                  <!-- <button @click="$router.push( { name:'DLessonsByCategory', params:{ schoolId: schoolId, departmentId:departmentId, categoryId: teacher.id } } )" class="btn btn-sm btn-primary">харах</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info text-center">
          Одоогоор мэдээлэл ороогүй байна.
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="proModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="proModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="proModalLabel">Бүлэг нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Бүлэг нэр</label>
                <select class="form-control" v-model="pro.name">
                  <option v-for="g in groups" v-bind:value="g">{{ g }}</option>
                </select>
                <!-- <input v-model.trim="pro.name" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хөтөлбөрийн нэр оруулна уу"> -->
              </div>
              <div class="row" v-if="teachers && teachers.length > 0">
                <div class="col form-group">
                  <label for="exampleFormControlSelect1"
                    >Анги удирдсан багш:</label
                  >
                  <select class="form-control" v-model="pro.teacher">
                    <option
                      v-for="teacher in teachers"
                      v-bind:key="'teacher-' + teacher.id"
                      v-bind:value="teacher.ref"
                    >
                      {{ teacher.name }} - {{ teacher.code }} -
                      {{ teacher.email }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- <div class="form-group">
                  <label>Бүлэгийн индекс</label>
                  <input v-model.trim="pro.hindex" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хөтөлбөрийн индекс оруулна уу">
                </div> -->
              <div class="form-group">
                <label>Онлайн уулзалтын линк</label>
                <textarea
                  rows="1"
                  v-model.trim="pro.onlineroom"
                  class="form-control"
                  placeholder="Онлайн уулзалтын линк"
                />
              </div>
              <div class="form-group">
                <label>Бүлэг дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="pro.description"
                  class="form-control"
                  placeholder="Бүлэг дэлгэрэнгүй оруулна уу"
                />
              </div>
              <!-- <div class="form-group">
                   <label>Хөтөлбөрийн багийн ахлагч</label>
                  <input v-model.trim="pro.teamLeader" class="form-control" placeholder="Бүлэгийн багийн ахлагч оруулна уу">
                </div>
                <div class="form-group">
                  <label>Холбоо барих утас</label>
                  <input v-model.trim="pro.phone" class="form-control" placeholder="Холбоо барих утас оруулна уу">
                </div>
                <div class="form-group">
                  <label>Имэйл хаяг</label>
                  <input v-model.trim="pro.email" class="form-control" placeholder="Имэйл хаяг оруулна уу">
                </div> -->

              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="save"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Xадгалаxxx22
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import myfunction from "./global/myfunction.js";
export default {
  name: "LessonDetail",
  data() {
    return {
      department: null,
      pro: {
        name: null,
        hindex: null,
        description: null,
        teamLeader: null,
        phone: null,
        email: null,
        teacher: null,
        onlineroom: null,
        index: null,
      },
      pros: [],
      groups: ["А", "Б", "В", "Г", "Д", "Е", "Ё", "Ж", "З", "И"],
      teachers: [],
      categories: [],
    };
  },
  mixins: [myfunction],
  methods: {
    _openLink(program) {
      if (program.onlineroom != null) window.open(program.onlineroom, "_blank");
    },
    _getQA() {
      fb.db
        .collection("schools/" + this.schoolId + "/teachers")
        .orderBy("name", "asc")
        .get()
        .then((docs) => {
          this.teachers = [];
          docs.docs.forEach((doc) => {
            let teacher = doc.data();
            teacher.id = doc.id;
            teacher.ref = doc.ref;
            this.teachers.push(teacher);
          });
        });

      fb.db
        .collection("schools/" + this.schoolId + "/categories")
        .orderBy("index", "asc")
        .get()
        .then((docs) => {
          this.categories = [];
          docs.docs.forEach((doc) => {
            let teacher = doc.data();
            teacher.id = doc.id;
            teacher.ref = doc.ref;
            this.categories.push(teacher);
          });
        });

      fb.db
        .collection("schools/" + this.schoolId + "/departments/")
        .doc(this.departmentId)
        .onSnapshot((doc) => {
          let department = doc.data();
          department.id = doc.id;
          this.department = department;
        });

      fb.db
        .collection(
          "schools/" +
            this.schoolId +
            "/departments/" +
            this.departmentId +
            "/programs"
        )
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.pros = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;
            object.teacherData = null;
            object.ref = doc.ref;
            if (object.onlineroom == undefined) object.onlineroom = null;
            if (object.teacher) {
              object.teacher.get().then((tdoc) => {
                if (tdoc.exists) {
                  object.teacherData = tdoc.data();
                }
              });
            }

            this.pros.push(object);

            // fb.db.collection("schools/"+this.schoolId+"/students").where("program", "==", doc.ref).get().then(stdocs=>{
            //   if(stdocs && !stdocs.empty){
            //     doc.ref.update({numberOfStudents: stdocs.size});
            //   }
            // });
          });
        });
    },

    save() {
      if (
        this.pro != null &&
        this.pro != null &&
        this.pro.name != "" &&
        this.pro.description != ""
      ) {
        if (this.pro.id != null && this.pro.id != "") {
          fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("departments")
            .doc(this.departmentId)
            .collection("programs")
            .doc(this.pro.id)
            .update({
              name: this.pro.name.toLowerCase(),
              hindex: this.pro.hindex ? this.pro.hindex : null,
              description: this.pro.description ? this.pro.description : null,
              teamLeader:
                this.pro.teamLeader != null && this.pro.teamLeader != undefined
                  ? this.pro.teamLeader
                  : "",
              phone:
                this.pro.phone != null && this.pro.phone != undefined
                  ? this.pro.phone
                  : "",
              email:
                this.pro.email != null && this.pro.email != undefined
                  ? this.pro.email
                  : "",
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              ),
              teacher: this.pro.teacher ? this.pro.teacher : null,
              onlineroom: this.pro.onlineroom,
              index: this.groups.indexOf(this.pro.name),
            });
        } else {
          this.pro.createdAt = new Date();
          this.pro.index = this.groups.indexOf(this.pro.name) + 1;
          this.pro.name = this.pro.name.toLowerCase();
          fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("departments")
            .doc(this.departmentId)
            .collection("programs")
            .doc()
            .set(this.pro);
          fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("departments")
            .doc(this.departmentId)
            .update({
              numberOfPrograms: fb.firestore.FieldValue.increment(1),
            });
        }
        this.pro = {
          name: null,
          hindex: null,
          description: null,
          teamLeader: null,
          phone: null,
          email: null,
          onlineroom: null,
          index: null,
        };
      }
    },

    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { schoolId: this.schoolId, type: type.id, topicId: topic.id },
      });
    },
    _addProgram() {
      this.pro = {};
      $("#proModal").modal("toggle");
    },
    _editProgram(pro) {
      this.pro = Object.assign({}, pro);
      $("#proModal").modal("toggle");
    },
    _deleteProgram(pro) {
      var result = confirm("Та " + pro.name + " хөтөлбөрийг устгах уу?");
      if (result) {
        fb.db
          .collection("schools")
          .doc(this.schoolId)
          .collection("departments")
          .doc(this.departmentId)
          .collection("programs")
          .doc(pro.id)
          .delete();
      }
    },
    getPercent(data) {
      if (data) {
        var active = 0;
        var off = 0;
        if (data.numberOfArrived) active = data.numberOfArrived;
        if (data.numberOfNotArrived) off = data.numberOfNotArrived;
        var sum = active + off;
        if (sum > 0) return ((active * 100) / sum).toFixed(2);
        else return null;
      }
      return null;
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
    departmentId: {
      required: true,
    },
  },
  created() {
    var _this = this;
    console.log(this.schoolId);
    if (
      this.schoolId != null &&
      this.schoolId != "" &&
      this.departmentId != null &&
      this.departmentId != ""
    )
      this._getQA();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    },
  },
};
</script>

